import React, { useState, useEffect } from "react";
import { Row, Col, Button } from "react-bootstrap";

import { useTopicContext } from "../../../../contexts/TopicContext";

export default function Filters({ keyword, setKeyword }) {
  const { dispatch, actions, state } = useTopicContext();

  return (
    <div className="invite_search">
      <Row>
        <Col md={3}>
          <form className="inviteSearch_form">
            <input
              type="text"
              placeholder="Topic Name"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
            />
          </form>
        </Col>
        <Col md={9} className="text-right">
          <Button
            onClick={() => actions.showCreateForm(dispatch)}
            bsStyle="primary"
          >
            Add Topic
          </Button>
        </Col>
      </Row>
    </div>
  );
}
